import { Tooltip, Typography } from '@mui/material';

export default function UserAccountNavigate({ user }) {

    return (
        <>
            {
                (!!user?.id || !!user?._id) ?
                    <Tooltip placement="top" title={user?.companyName}>
                        <Typography
                            variant='body2'
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open(`/admin/merchants/${user?.id ?? user?._id}`, '_blank')
                            }}
                            sx={{
                                cursor: 'pointer',
                                "&:hover": { color: 'primary.main' }
                            }}
                        >
                            {user?.companyName}
                        </Typography>
                    </Tooltip>
                    :
                    <Typography variant='body2' color='text.secondary'>-</Typography>
            }
        </>
    )
}
